export const goTo = (id: string) => {
  const tmp = document.getElementById(id);
  if (tmp) tmp.scrollIntoView({ behavior: "smooth" });
  else console.warn(`Element ${id} not found`);
};
